<template>
  <div class="content-text">
    <h2 class="title-2 text-left">4 Qualidade</h2>

    <p>
      O componente de qualidade visa estimular o alcance de indicadores com o
      objetivo de incentivar a melhoria do acesso da população aos serviços de
      saúde e a qualidade da prestação dos serviços oferecidos na APS para a
      população do território, buscando induzir boas práticas e aperfeiçoar os
      serviços na APS municipal.
    </p>

    <p>
      O Quadro 4 apresenta os valores por tipo de equipe e também o valor total
      por equipe.
    </p>

    <div class="container-table">
      <span style="text-transform: uppercase; font-weight: bold"
        >Quadro 4 - Valores por tipo de equipe no componente qualidade</span
      >
      <table>
        <thead>
          <tr>
            <th>EQUIPES</th>
            <th>QUANTIDADE</th>
            <th>CLASSIFICAÇÃO</th>
            <th>VALOR POR EQUIPE</th>
            <th>TOTAL POR EQUIPE</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in equipes.filter((el) => el.quantidade > 0)"
            :key="index"
          >
            <td>{{ item.label }}</td>
            <td class="text-right">{{ item.quantidade }}</td>
            <td>{{ item.classificacao }}</td>
            <td class="text-right">R$ {{ item.valorPorEquipe }}</td>
            <td class="text-right">R$ {{ item.valorTotalPorEquipe }}</td>
          </tr>
          <tr>
            <td colspan="4">Total geral</td>
            <td class="text-right">
              R$
              {{
                totalGeral.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })
              }}
            </td>
          </tr>
        </tbody>
      </table>
      <span class="fonte" v-html="fonte"></span>
    </div>

    <p>
      No período de transição, a classificação máxima é <b>"BOM"</b>. A partir
      de maio de 2025, essa classificação poderá ser no máximo <b>"ÓTIMA"</b>,
      como melhor desempenho, ou, no pior cenário, <b>"REGULAR"</b>, como pior
      desempenho. Como a avaliação é retroativa, a implementação de M & A na APS
      desde de maio de 2024 torna mais fácil alcançar o melhor desempenho após o
      período de transição.
    </p>
  </div>
</template>

<script>
export default {
  props: {
    dados: {
      type: Object,
      default: () => {},
    },
    regras: {
      type: Array,
      default: () => {},
    },
    fonte: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      equipes: [],
      totalGeral: 0,
    }
  },
  mounted() {
    this.formatarEquipes()
  },
  computed: {},
  methods: {
    formatarEquipes() {
      const equipesImplantadas = this.dados.etapa4
      if (equipesImplantadas != null) {
        for (let label in equipesImplantadas) {
          let totalPorEquipe = 0
          const resultado = this.regras.find((item) => item.label === label)
          if (resultado) {
            const classificacaoEquipe = resultado.classificacao.find(
              (el) => el.tipo == 'Bom'
            )
            let quantidadeDeEquipes = equipesImplantadas[label]
            totalPorEquipe += classificacaoEquipe.valor * quantidadeDeEquipes
            this.equipes.push({
              label: resultado.label,
              quantidade: equipesImplantadas[label],
              classificacao: 'BOM',
              valorPorEquipe: classificacaoEquipe.valor.toLocaleString(
                'pt-BR',
                {
                  minimumFractionDigits: 2,
                }
              ),
              valorTotalPorEquipe: totalPorEquipe.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              }),
            })

            this.totalGeral += totalPorEquipe
          }
        }
      }
    },
  },
}
</script>

<style lang="scss"></style>
